import { render, staticRenderFns } from "./BulkActionModal.vue?vue&type=template&id=32f811e8&scoped=true&"
import script from "./BulkActionModal.vue?vue&type=script&lang=js&"
export * from "./BulkActionModal.vue?vue&type=script&lang=js&"
import style0 from "./BulkActionModal.vue?vue&type=style&index=0&id=32f811e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f811e8",
  null
  
)

export default component.exports